import BaseValidation from '@/forms/Validations/BaseValidation';
import NameValidation from '@/forms/FormElements/Rows/NameRow/NameRow.validation';
import EmailValidation from '@/forms/FormElements/Rows/EmailRow/EmailRow.validation';
import { requiredIf } from 'vuelidate/lib/validators';
import { zipCode } from '@/forms/Validations/CommonRules';
import { formNames as names} from '../NewsletterPopup.types'
import CheckBoxValidation from '@/forms/FormElements/Rows/CheckBoxRow/CheckBox.validation';

export default () => {
  const getZipIf = (value: string) => {
    return zipCode(value);
  };

  const zipCodeValidation = new BaseValidation([
    {
      name: names.PostalCode,
      rules: {
        required: requiredIf(function() {
          //@ts-ignore
          return this.ShowGate
        }),
        zipCode: getZipIf,
      },
      messages: {
        required: 'Enter a zip code',
        zipCode: 'Enter a valid zip code',
      },
    },
  ]);

  const validations = [
    NameValidation('', { removeTitle: true }),
    EmailValidation(),
    CheckBoxValidation(),
  ];

  return {
    validations: BaseValidation.getRules(validations),
    messages: BaseValidation.getMessages(validations),
    model: BaseValidation.getModel(validations),
  };
};
